/**
 * What each page says about itself outside its own body: the share-preview
 * title, the search-result description and the canonical address. One entry
 * per route in App.js, kept together so every title can be read at once.
 *
 * The browser tab always reads just the site name; `title` here is only used
 * in the Open Graph tags a link preview shows.
 *
 * public/index.html carries the home page's values as static markup, for the
 * link-preview scrapers that do not run JavaScript. PageMeta keeps the tags
 * current once the router takes over.
 */
export const siteName = 'Annpriya';
export const siteUrl = 'https://annpriya.com';

const t = (page) => `${page} · ${siteName}`;

export const pageMeta = {
  '/': {
    title: 'Annpriya: pesticide-free produce, grown for 500 families',
    description:
      'Pesticide-free greens, herbs and vegetables from a hydroponic and aeroponic greenhouse in Jaipur that instruments every tray. Harvested in the morning, on your table by dinner.',
  },
  '/farm-tech': {
    title: t('Growing methods'),
    description:
      'Vertical, hydroponic and aeroponic growing under precision control, and the closed-loop system that decides what every plant is fed.',
  },
  '/farm-tech/system': {
    title: t('The system'),
    description:
      'The Automated Smart Nutrient Management System: closed-loop measurement, deterministic decisioning, and reasoning that runs on site rather than in a cloud.',
  },
  '/farm-tech/architecture': {
    title: t('Architecture'),
    description:
      'What each layer of the nutrient system is responsible for, what that responsibility demanded of it, and what it hands to the layer above.',
  },
  '/farm-tech/dosing': {
    title: t('Decision & dosing'),
    description:
      'How a dose is computed: from measured state to a required change to an executable quantity, and why the engine always rounds down.',
  },
  '/farm-tech/safety': {
    title: t('Safety & actuation'),
    description:
      'The central gate. Nothing reaches an actuator without being authorised here first, and it is built so that the answer cannot be argued with.',
  },
  '/farm-tech/components': {
    title: t('Guarantees'),
    description:
      'What every layer of the system promises, and for each one, how a failure would make itself visible rather than pass unnoticed.',
  },
  '/about': {
    title: t('About'),
    description:
      'A collective of growers, scientists and engineers in Jaipur who believe food should be grown with integrity, eaten with joy, and delivered with transparency.',
  },
  '/membership': {
    title: t('Membership'),
    description:
      'Grown for 500 families and no more: a weekly harvest box, farm experiences, and a place in a community that values purity and a harvest grown deliberately small.',
  },
  '/sustainability': {
    title: t('Sustainability'),
    description:
      'Every box is part of an argument that premium food and a lighter footprint are not opposites: operational choices, not aspirations.',
  },
  '/experiences': {
    title: t('Experiences'),
    description:
      'Harvest dinners, farm tours and workshops that connect you to your food, the farm, and the people growing it.',
  },
  '/faq': {
    title: t('FAQ'),
    description: 'Membership, growing methods, and how much of the system is actually automated.',
  },
  '/contact': {
    title: t('Contact'),
    description:
      'About membership, a farm visit, or the nutrient system itself. A person reads everything that comes in.',
  },
};
